import React from "react";
import { Archive, East } from "@mui/icons-material";
import { Divider, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useProfile } from "../../common/useProfile";

const ITEM_HEIGHT = 48;
export default function KanbanCardMoverTodosMenu(props) {
    const { action, col, kanban, arquivarTodos, moverTodos } = props;
    const prof = useProfile();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    function handleArquivar(){
        console.log('>>>handleArquivar<<<');
        arquivarTodos();
    }
    function handleMenuItem(row) {
        
        moverTodos(row);
        // const dado = {
        //     id: cartao.id,
        //     idColuna: row.id
        // }
        // if (action) action( dado );
    }
    
    return (
        <React.Fragment>
            <MenuItem onClick={handleClick}>
                <ListItemIcon size='small'>
                    <East fontSize="small" />
                </ListItemIcon>
                Mover todo cartões
            </MenuItem>

            <Menu sx={{ width: 520, maxWidth: '100%' }}
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        style: {
                            maxHeight: ITEM_HEIGHT * 10.5,
                            width: '30ch',
                        },
                    },
                    list: {
                        'aria-labelledby': 'long-button',
                    },
                }}
                size='small'
            >
                {kanban && kanban.colunas && kanban.colunas.map( (row, id) =>{
                    if( row.id === col.id) return;
                    if( row.regra ){
                        if( !prof.temAcesso(row.regra)){
                            return;
                        }
                    }
                    return (
                        <MenuItem key={'m-'+id} onClick={() => handleMenuItem(row) }>{row.nome} </MenuItem>
                    )
                })}
                { prof.temAcesso("ArquivarCartoes") && <React.Fragment>
                <Divider />
                <MenuItem onClick={handleArquivar}>
                    <ListItemIcon size='small'>
                        <Archive fontSize="small" />
                    </ListItemIcon>
                    Arquivar
                </MenuItem>
                </React.Fragment>}
            </Menu>
        </React.Fragment>
    )
}